/**
 * @fileoverview Canonical path for the signed-in shell homepage.
 * @purpose Used by `GET /` redirects and `shellConfig.routes.homepage` — keep one value to avoid drift.
 */

export const AUTHENTICATED_SHELL_HOMEPAGE_PATH = '/home';
